export default __webpack_public_path__ + "static/media/SIW400G_T100_W0.601eef17.webp";